import { Directive, HostBinding, Input, TemplateRef } from '@angular/core';

@Directive({
  selector: '[appMuTableNotFound]',
})
export class MuTableNotFoundDirective {
  @Input('appMuTableNotFound') name: string;
  @HostBinding('style.border') styleBorder = '2px solid red';

  constructor(public template: TemplateRef<any>) {
    /** */
  }
}
